// src/pages/StartPage.js

import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import LanguageSwitcher from '../components/LanguageSwitcher'; // <--- LanguageSwitcher importieren!
import Logo from '../components/Logo';

function StartPage() {
  const navigate = useNavigate();
  const { t } = useTranslation();

  function handleLogin() {
    navigate('/login');
  }

  return (
    // Das parent-DIV braucht relative Positionierung, damit der LanguageSwitcher absolut platziert werden kann
    <div
      className="min-h-screen bg-black text-white flex flex-col items-center justify-center p-6"
      style={{ position: 'relative' }}
    >
      {/* Language Switcher */}
      <LanguageSwitcher />

      {/* Logo */}
      <div className="mb-12">
        <Logo variant="wordmark" size="xxxl" />
      </div>

      {/* Überschrift */}
      <h1 className="text-4xl md:text-5xl font-bold mb-8 text-center">
        {t('welcome')}
      </h1>

      {/* Beschreibung */}
      <p className="text-lg md:text-xl text-gray-400 mb-12 text-center max-w-2xl">
        {t('description')}
      </p>

      {/* Aktionen */}
      <div className="flex gap-6 flex-wrap justify-center">
        <button
          onClick={handleLogin}
          className="bg-mentixxgreen hover:bg-green-400 text-black font-bold py-3 px-8 rounded-2xl transition"
        >
          {t('login')}
        </button>
      </div>

      {/* Footer */}
      <div className="mt-16 text-gray-500 text-sm text-center">
        © {new Date().getFullYear()} MΞNVIO. {t('copyright')}
      </div>
    </div>
  );
}

export default StartPage;

